import Button from '@/shared/Buttons/Button'
import timeUtils from '@/utils/time.utils'
import ArrowRight from '@/assets/icons/arrowRight.svg?react'
import ArrowLeft from '@/assets/icons/arrowLeft.svg?react'
import calendarPageConstants from '../calendar.constants'
import { IMaintenanceEventFilters, TSectionType } from '../calendar.types'
import calendarUtils from '../calendar.utils'
import { useMemo } from 'react'

interface IProps {
  onDateChange: (dates: IMaintenanceEventFilters) => void
  selectedDates: IMaintenanceEventFilters
  selectedSection: TSectionType
  viewingMode: 'range' | 'monthYear'
}

const DateButtonGroup = (props: IProps) => {
  const formattedDate = useMemo(
    () => timeUtils.formatDate(calendarUtils.getCurrentMonth(props.selectedSection, props.selectedDates), 'MMMM, yyyy'),
    [props.selectedSection, props.selectedDates]
  )

  const renderDateLabel = () => {
    if (props.viewingMode === 'monthYear') {
      return (
        <span style={{ textTransform: 'capitalize' }} className="text-heading-4">
          {`${calendarPageConstants.calendarDays[formattedDate.split(',')[0]]}, ${formattedDate.split(',')[1]}`}
        </span>
      )
    }

    return (
      <span style={{ textTransform: 'capitalize' }} className="text-heading-4">
        {`${timeUtils.formatDate(props.selectedDates.date_gte, 'dd.MM.yyyy')} — ${timeUtils.formatDate(props.selectedDates.date_lte, 'dd.MM.yyyy')}`}
      </span>
    )
  }

  return (
    <div
      className="inline-flex-gap flex-space-between center"
      style={{ width: props.viewingMode === 'monthYear' ? '260px' : '360px' }}
    >
      <Button
        size={'default'}
        type={'default'}
        onClick={() => props.onDateChange(calendarUtils.decrementDates(props.selectedDates, props.selectedSection))}
        icon={<ArrowLeft />}
      />
      {renderDateLabel()}
      <Button
        size={'default'}
        type={'default'}
        onClick={() => props.onDateChange(calendarUtils.incrementDates(props.selectedDates, props.selectedSection))}
        icon={<ArrowRight />}
      />
    </div>
  )
}

export default DateButtonGroup
